module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_search_white-41d605b9d8548cff27938fe489657cb5.svg";